export const Shows = ({ color }) => {
  return (
    <span className="shows-icon" style={{ color }}>
      2
    </span>
  );
};
